// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc } from '../../components/ProductOfferingConfigUtils.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyProductOfferingConfigPageMetaQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ApplyProductOfferingConfigPageMetaQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Structure', id: string, isAdu: boolean, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
    | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> }
  , changeEventReasons: Array<{ __typename?: 'ChangeEventReason', id: string, code: string }> };

export type ApplyProductOfferingConfig_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Structure_Fragment = { __typename?: 'Structure', id: string, isAdu: boolean, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }> } | null | undefined, stages: Array<{ __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage } }> };

export type ApplyProductOfferingConfig_ProjectFragment =
  | ApplyProductOfferingConfig_Project_StandaloneProject_Fragment
  | ApplyProductOfferingConfig_Project_Region_Fragment
  | ApplyProductOfferingConfig_Project_Market_Fragment
  | ApplyProductOfferingConfig_Project_Community_Fragment
  | ApplyProductOfferingConfig_Project_Subdivision_Fragment
  | ApplyProductOfferingConfig_Project_Lot_Fragment
  | ApplyProductOfferingConfig_Project_Structure_Fragment
  | ApplyProductOfferingConfig_Project_Unit_Fragment
;

export type ApplyProductOfferingConfig_SelectedQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  skipProductOfferingConfig: Types.Scalars['Boolean']['input'];
  skipCheckoutConfig: Types.Scalars['Boolean']['input'];
  skipProjectReadyPlanConfig: Types.Scalars['Boolean']['input'];
  skipStartingConfig: Types.Scalars['Boolean']['input'];
}>;


export type ApplyProductOfferingConfig_SelectedQuery = { __typename?: 'Query', productOfferingConfig?: { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } }, checkoutConfig?: { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, isReversed: boolean, productOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } | null | undefined, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string } } } | null | undefined }> }, productOfferingStartingConfig?: { __typename?: 'ProductOfferingStartingConfig', id: string, name: string, expandedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } }, projectReadyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, orientation: Types.ProjectReadyPlanConfigOrientation, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, readyPlan?:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
     | null | undefined } };

export type ApplyProductOfferingConfig_ComputeQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  readyPlanOptionIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  originalReadyPlanOptionIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ApplyProductOfferingConfig_ComputeQuery = { __typename?: 'Query', computeReadyPlanCost: { __typename?: 'ComputeReadyPlanCostResult', configurationErrors: Array<string>, readyPlan: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, protoProjectItems: Array<{ __typename?: 'ProtoProjectItem', totalCostInCents: number, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
       | null | undefined, modifyingTemplateItems: Array<
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      > }> } };

export type ApplyProductOfferingConfig_ComputeResultFragment = { __typename?: 'ComputeReadyPlanCostResult', configurationErrors: Array<string>, readyPlan: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, protoProjectItems: Array<{ __typename?: 'ProtoProjectItem', totalCostInCents: number, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
     | null | undefined, modifyingTemplateItems: Array<
      | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
    > }> };

export type ApplyProductOfferingConfig_LineItem_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type ApplyProductOfferingConfig_LineItem_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type ApplyProductOfferingConfig_LineItem_ProjectCustomItem_Fragment = { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type ApplyProductOfferingConfig_LineItem_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type ApplyProductOfferingConfig_LineItem_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type ApplyProductOfferingConfig_LineItemFragment =
  | ApplyProductOfferingConfig_LineItem_ItemTemplateItemVersion_Fragment
  | ApplyProductOfferingConfig_LineItem_ItemTemplateItem_Fragment
  | ApplyProductOfferingConfig_LineItem_ProjectCustomItem_Fragment
  | ApplyProductOfferingConfig_LineItem_TakeoffLineItem_Fragment
  | ApplyProductOfferingConfig_LineItem_TakeoffLineItemVersion_Fragment
;

export type ApplyProductOfferingConfigMetaQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
  productOfferingVersionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ApplyProductOfferingConfigMetaQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, publishToUnderwriting: boolean, name: string, options: Array<{ __typename?: 'ReadyPlanOption', displayName: string, order: number, active: boolean, id: string, name: string, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, active: boolean, order: number, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined } }>, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string } } };

export type ApplyProductOfferingConfig_ProductOfferingConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } };

export type ApplyProductOfferingConfig_StartingConfigFragment = { __typename?: 'ProductOfferingStartingConfig', id: string, name: string, expandedOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } };

export type ApplyProductOfferingConfig_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, isReversed: boolean, productOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string, aggregateCheckout?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined } | null | undefined, optionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string, readyPlan: { __typename?: 'ReadyPlan', id: string } } } | null | undefined }> };

export type ApplyProductOfferingConfigsMutationVariables = Types.Exact<{
  input: Types.SaveProjectReadyPlanConfigsInput;
}>;


export type ApplyProductOfferingConfigsMutation = { __typename?: 'Mutation', saveProjectReadyPlanConfigs: { __typename?: 'SaveProjectReadyPlanConfigsResult', projectReadyPlanConfigs: Array<{ __typename?: 'ProjectReadyPlanConfig', id: string }> } };

export type CreateProductOfferingConfigChangeEventMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventInput;
}>;


export type CreateProductOfferingConfigChangeEventMutation = { __typename?: 'Mutation', saveChangeEvent: { __typename?: 'SaveChangeEventResult', changeEvent: { __typename?: 'ChangeEvent', id: string } } };

export const ApplyProductOfferingConfig_ProjectFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_Project on Project {
  ...Named
  ... on Structure {
    id
    isAdu
  }
  readyPlanConfig {
    id
    orientation
    readyPlan {
      ...Named
    }
    readyPlanOptions {
      id
    }
  }
  stages {
    id
    hasSignedContract
    stage {
      code
    }
  }
}
    ${NamedFragmentDoc}`;
export const ApplyProductOfferingConfig_LineItemFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_LineItem on BaseItemLike {
  id
  totalCostInCents
  options {
    id
    displayName
  }
}
    `;
export const ApplyProductOfferingConfig_ComputeResultFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_ComputeResult on ComputeReadyPlanCostResult {
  readyPlan {
    id
    optionGroups {
      id
      order
      options {
        id
        displayName
      }
    }
  }
  readyPlanOptions {
    id
  }
  protoProjectItems {
    totalCostInCents
    itemTemplateItem {
      ...ApplyProductOfferingConfig_LineItem
    }
    modifyingTemplateItems {
      ...ApplyProductOfferingConfig_LineItem
    }
  }
  configurationErrors
}
    ${ApplyProductOfferingConfig_LineItemFragmentDoc}`;
export const ApplyProductOfferingConfig_ProductOfferingConfigFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_ProductOfferingConfig on ProductOfferingConfig {
  id
  name
  isBaseConfig
  salesPriceInCents
  readyPlanOptions {
    id
  }
  publishToUnderwriting
  productOffering {
    id
    aggregateCheckout {
      id
    }
  }
}
    `;
export const ApplyProductOfferingConfig_StartingConfigFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_StartingConfig on ProductOfferingStartingConfig {
  id
  name
  expandedOptions {
    id
  }
  productOffering {
    id
    aggregateCheckout {
      id
    }
  }
}
    `;
export const ApplyProductOfferingConfig_CheckoutConfigFragmentDoc = gql`
    fragment ApplyProductOfferingConfig_CheckoutConfig on CheckoutConfig {
  id
  name
  isReversed
  productOffering {
    id
    aggregateCheckout {
      id
    }
  }
  aduProductOffering {
    id
    aggregateCheckout {
      id
    }
  }
  optionGroups {
    id
    step
    selectedOption {
      id
      option {
        id
        readyPlan {
          id
        }
      }
    }
  }
}
    `;
export const ApplyProductOfferingConfigPageMetaDocument = gql`
    query ApplyProductOfferingConfigPageMeta($projectId: ID!) {
  project(id: $projectId) {
    ...ApplyProductOfferingConfig_Project
  }
  changeEventReasons {
    id
    code
  }
}
    ${ApplyProductOfferingConfig_ProjectFragmentDoc}`;

/**
 * __useApplyProductOfferingConfigPageMetaQuery__
 *
 * To run a query within a React component, call `useApplyProductOfferingConfigPageMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyProductOfferingConfigPageMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyProductOfferingConfigPageMetaQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useApplyProductOfferingConfigPageMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables> & ({ variables: ApplyProductOfferingConfigPageMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>(ApplyProductOfferingConfigPageMetaDocument, options);
      }
export function useApplyProductOfferingConfigPageMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>(ApplyProductOfferingConfigPageMetaDocument, options);
        }
// @ts-ignore
export function useApplyProductOfferingConfigPageMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>;
export function useApplyProductOfferingConfigPageMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfigPageMetaQuery | undefined, ApplyProductOfferingConfigPageMetaQueryVariables>;
export function useApplyProductOfferingConfigPageMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>(ApplyProductOfferingConfigPageMetaDocument, options);
        }
export type ApplyProductOfferingConfigPageMetaQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigPageMetaQuery>;
export type ApplyProductOfferingConfigPageMetaLazyQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigPageMetaLazyQuery>;
export type ApplyProductOfferingConfigPageMetaSuspenseQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigPageMetaSuspenseQuery>;
export type ApplyProductOfferingConfigPageMetaQueryResult = ApolloReactCommon.QueryResult<ApplyProductOfferingConfigPageMetaQuery, ApplyProductOfferingConfigPageMetaQueryVariables>;
export const ApplyProductOfferingConfig_SelectedDocument = gql`
    query ApplyProductOfferingConfig_Selected($id: ID!, $skipProductOfferingConfig: Boolean!, $skipCheckoutConfig: Boolean!, $skipProjectReadyPlanConfig: Boolean!, $skipStartingConfig: Boolean!) {
  productOfferingConfig(id: $id) @skip(if: $skipProductOfferingConfig) {
    ...ApplyProductOfferingConfig_ProductOfferingConfig
  }
  checkoutConfig(id: $id) @skip(if: $skipCheckoutConfig) {
    ...ApplyProductOfferingConfig_CheckoutConfig
  }
  productOfferingStartingConfig(id: $id) @skip(if: $skipStartingConfig) {
    ...ApplyProductOfferingConfig_StartingConfig
  }
  projectReadyPlanConfig(id: $id) @skip(if: $skipProjectReadyPlanConfig) {
    id
    orientation
    readyPlanOptions {
      id
    }
    readyPlan {
      ...Named
      ... on ProductOffering {
        id
        aggregateCheckout {
          id
        }
      }
    }
  }
}
    ${ApplyProductOfferingConfig_ProductOfferingConfigFragmentDoc}
${ApplyProductOfferingConfig_CheckoutConfigFragmentDoc}
${ApplyProductOfferingConfig_StartingConfigFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useApplyProductOfferingConfig_SelectedQuery__
 *
 * To run a query within a React component, call `useApplyProductOfferingConfig_SelectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyProductOfferingConfig_SelectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyProductOfferingConfig_SelectedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skipProductOfferingConfig: // value for 'skipProductOfferingConfig'
 *      skipCheckoutConfig: // value for 'skipCheckoutConfig'
 *      skipProjectReadyPlanConfig: // value for 'skipProjectReadyPlanConfig'
 *      skipStartingConfig: // value for 'skipStartingConfig'
 *   },
 * });
 */
export function useApplyProductOfferingConfig_SelectedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables> & ({ variables: ApplyProductOfferingConfig_SelectedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>(ApplyProductOfferingConfig_SelectedDocument, options);
      }
export function useApplyProductOfferingConfig_SelectedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>(ApplyProductOfferingConfig_SelectedDocument, options);
        }
// @ts-ignore
export function useApplyProductOfferingConfig_SelectedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>;
export function useApplyProductOfferingConfig_SelectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfig_SelectedQuery | undefined, ApplyProductOfferingConfig_SelectedQueryVariables>;
export function useApplyProductOfferingConfig_SelectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>(ApplyProductOfferingConfig_SelectedDocument, options);
        }
export type ApplyProductOfferingConfig_SelectedQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_SelectedQuery>;
export type ApplyProductOfferingConfig_SelectedLazyQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_SelectedLazyQuery>;
export type ApplyProductOfferingConfig_SelectedSuspenseQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_SelectedSuspenseQuery>;
export type ApplyProductOfferingConfig_SelectedQueryResult = ApolloReactCommon.QueryResult<ApplyProductOfferingConfig_SelectedQuery, ApplyProductOfferingConfig_SelectedQueryVariables>;
export const ApplyProductOfferingConfig_ComputeDocument = gql`
    query ApplyProductOfferingConfig_Compute($readyPlanId: ID!, $readyPlanOptionIds: [ID!]!, $originalReadyPlanOptionIds: [ID!]) {
  computeReadyPlanCost(
    input: {readyPlanId: $readyPlanId, readyPlanOptionIds: $readyPlanOptionIds, versionMode: CHECKOUT, originalReadyPlanOptionIds: $originalReadyPlanOptionIds}
  ) {
    ...ApplyProductOfferingConfig_ComputeResult
  }
}
    ${ApplyProductOfferingConfig_ComputeResultFragmentDoc}`;

/**
 * __useApplyProductOfferingConfig_ComputeQuery__
 *
 * To run a query within a React component, call `useApplyProductOfferingConfig_ComputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyProductOfferingConfig_ComputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyProductOfferingConfig_ComputeQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      readyPlanOptionIds: // value for 'readyPlanOptionIds'
 *      originalReadyPlanOptionIds: // value for 'originalReadyPlanOptionIds'
 *   },
 * });
 */
export function useApplyProductOfferingConfig_ComputeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables> & ({ variables: ApplyProductOfferingConfig_ComputeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>(ApplyProductOfferingConfig_ComputeDocument, options);
      }
export function useApplyProductOfferingConfig_ComputeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>(ApplyProductOfferingConfig_ComputeDocument, options);
        }
// @ts-ignore
export function useApplyProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>;
export function useApplyProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfig_ComputeQuery | undefined, ApplyProductOfferingConfig_ComputeQueryVariables>;
export function useApplyProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>(ApplyProductOfferingConfig_ComputeDocument, options);
        }
export type ApplyProductOfferingConfig_ComputeQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_ComputeQuery>;
export type ApplyProductOfferingConfig_ComputeLazyQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_ComputeLazyQuery>;
export type ApplyProductOfferingConfig_ComputeSuspenseQueryHookResult = ReturnType<typeof useApplyProductOfferingConfig_ComputeSuspenseQuery>;
export type ApplyProductOfferingConfig_ComputeQueryResult = ApolloReactCommon.QueryResult<ApplyProductOfferingConfig_ComputeQuery, ApplyProductOfferingConfig_ComputeQueryVariables>;
export const ApplyProductOfferingConfigMetaDocument = gql`
    query ApplyProductOfferingConfigMeta($productOfferingId: ID!, $productOfferingVersionId: ID) {
  productOffering(id: $productOfferingId, versionId: $productOfferingVersionId) {
    id
    publishToUnderwriting
    ...Named
    options {
      ...ProductOfferingConfigUtils_ReadyPlanOption
    }
    status {
      code
      name
    }
  }
}
    ${NamedFragmentDoc}
${ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc}`;

/**
 * __useApplyProductOfferingConfigMetaQuery__
 *
 * To run a query within a React component, call `useApplyProductOfferingConfigMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyProductOfferingConfigMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyProductOfferingConfigMetaQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *      productOfferingVersionId: // value for 'productOfferingVersionId'
 *   },
 * });
 */
export function useApplyProductOfferingConfigMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables> & ({ variables: ApplyProductOfferingConfigMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>(ApplyProductOfferingConfigMetaDocument, options);
      }
export function useApplyProductOfferingConfigMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>(ApplyProductOfferingConfigMetaDocument, options);
        }
// @ts-ignore
export function useApplyProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>;
export function useApplyProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyProductOfferingConfigMetaQuery | undefined, ApplyProductOfferingConfigMetaQueryVariables>;
export function useApplyProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>(ApplyProductOfferingConfigMetaDocument, options);
        }
export type ApplyProductOfferingConfigMetaQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigMetaQuery>;
export type ApplyProductOfferingConfigMetaLazyQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigMetaLazyQuery>;
export type ApplyProductOfferingConfigMetaSuspenseQueryHookResult = ReturnType<typeof useApplyProductOfferingConfigMetaSuspenseQuery>;
export type ApplyProductOfferingConfigMetaQueryResult = ApolloReactCommon.QueryResult<ApplyProductOfferingConfigMetaQuery, ApplyProductOfferingConfigMetaQueryVariables>;
export const ApplyProductOfferingConfigsDocument = gql`
    mutation ApplyProductOfferingConfigs($input: SaveProjectReadyPlanConfigsInput!) {
  saveProjectReadyPlanConfigs(input: $input) {
    projectReadyPlanConfigs {
      id
    }
  }
}
    `;

/**
 * __useApplyProductOfferingConfigsMutation__
 *
 * To run a mutation, you first call `useApplyProductOfferingConfigsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyProductOfferingConfigsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyProductOfferingConfigsMutation, { data, loading, error }] = useApplyProductOfferingConfigsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyProductOfferingConfigsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApplyProductOfferingConfigsMutation, ApplyProductOfferingConfigsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApplyProductOfferingConfigsMutation, ApplyProductOfferingConfigsMutationVariables>(ApplyProductOfferingConfigsDocument, options);
      }
export type ApplyProductOfferingConfigsMutationHookResult = ReturnType<typeof useApplyProductOfferingConfigsMutation>;
export type ApplyProductOfferingConfigsMutationResult = ApolloReactCommon.MutationResult<ApplyProductOfferingConfigsMutation>;
export const CreateProductOfferingConfigChangeEventDocument = gql`
    mutation CreateProductOfferingConfigChangeEvent($input: SaveChangeEventInput!) {
  saveChangeEvent(input: $input) {
    changeEvent {
      id
    }
  }
}
    `;

/**
 * __useCreateProductOfferingConfigChangeEventMutation__
 *
 * To run a mutation, you first call `useCreateProductOfferingConfigChangeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductOfferingConfigChangeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductOfferingConfigChangeEventMutation, { data, loading, error }] = useCreateProductOfferingConfigChangeEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductOfferingConfigChangeEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductOfferingConfigChangeEventMutation, CreateProductOfferingConfigChangeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductOfferingConfigChangeEventMutation, CreateProductOfferingConfigChangeEventMutationVariables>(CreateProductOfferingConfigChangeEventDocument, options);
      }
export type CreateProductOfferingConfigChangeEventMutationHookResult = ReturnType<typeof useCreateProductOfferingConfigChangeEventMutation>;
export type CreateProductOfferingConfigChangeEventMutationResult = ApolloReactCommon.MutationResult<CreateProductOfferingConfigChangeEventMutation>;